export default __webpack_public_path__ + "static/media/1.bc343b79.svg";